/**
 * Define the Route List items
 */
import React from 'react';
import NoPermission from '../Modules/Core/NoPermission/NoPermission';
import { faCircle } from '@fortawesome/free-regular-svg-icons';

import Splash from '../Modules/Login/Pages/Splash';
import Users from '../Modules/User/Pages/Users';
import AddUser from '../Modules/User/Pages/AddUser';
import generateRolloutIcon from '../assets/images/generate-rollout.svg';
import webhookLogsIcon from '../assets/images/webhook_logs.svg';
import ObjectChangeLogIcon from '../assets/images/object_change_log.svg';
import AffectedFileIcon from '../assets/images/affected_file.svg';
import {
  faBug,
  faBox,
  faGear,
  faUmbrella,
  faChartPie
} from '@fortawesome/free-solid-svg-icons';
import Account from '../Modules/User/Pages/Account';
import Projects from '../Modules/Projects/Pages/Projects';
import CreateRollout from '../Modules/Projects/Pages/CreateRollout';
import RolloutList from '../Modules/RolloutList/Pages/RolloutList';
import AffectedFileDetail from '../Modules/AffectedFileDetail/Pages/AffectedFileDetail';
import AffectedFiles from '../Modules/AffectedFiles/Pages/AffectedFiles';
import WebHookLogs from '../Modules/WebHookLogs/Pages/WebHookLogs';
import Setting from '../Modules/Settings/Pages/Setting';
import SocialLoginRedirect from '../Modules/Login/Components/SocialLoginRedirect';
import GenerateRollout from '../Modules/Rollout/Pages/GenerateRollout';
import Dashboard from '../Modules/Dashboard/Pages/Dashboard';

const RoutesItemsList = [
  {
    text: '',
    icon: '',
    route: '/login',
    element: <Splash />,
    layouts: 'EmptyLayout',
    is_drawer_item: 'false',
    page_title: 'Login',
    isauth: false,
    is_mobile: 'true',
  },
  {
    ['data-expanded']: false,
    text: 'Users',
    icon: '',
    route: '/users',
    element: <Users />,
    layouts: 'CardLayout',
    is_drawer_item: 'false',
    page_title: 'Users',
    isauth: true,
    is_mobile: 'true',
    iconsvg: faBox,
    icon_type: "FontAwesomeIcon",
  },
  {
    text: 'AddUsers',
    icon: 'k-i-minus',
    iconsvg: faCircle,
    route: '/add-users',
    element: <AddUser />,
    layouts: 'CardLayout',
    is_drawer_item: 'false',
    page_title: 'Add Users',
    isauth: true,
    is_mobile: 'true',
    icon_type: "FontAwesomeIcon",
  },
  {
    text: 'Dashboard',
    icon: 'k-i-graph',
    id: 16,
    page_title: 'Dashboard',
    element: <Dashboard />,
    route: '/',
    layouts: 'TileLayout',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    iconsvg: faChartPie,
    icon_type: "FontAwesomeIcon",
  },
  {
    id: 3,
    text: 'Projects',
    icon: '',
    route: '/projects',
    element: <Projects />,
    layouts: 'CardLayout',
    is_drawer_item: 'true',
    page_title: 'Project List',
    isauth: true,
    is_mobile: 'true',
    iconsvg: faBox,
    icon_type: "FontAwesomeIcon",
  },
  {
    id: 5,
    text: 'Bugzilla',
    icon: '',
    route: '/bugzilla',
    layouts: 'CardLayout',
    is_drawer_item: 'false',
    page_title: 'Bugzilla',
    isauth: true,
    is_mobile: 'true',
    iconsvg: faBug,
    icon_type: "FontAwesomeIcon",
  },
  {
    id: 6,
    ['data-expanded']: false,
    text: 'Utilities',
    icon: '',
    layouts: 'CardLayout',
    is_drawer_item: 'true',
    page_title: 'Utilities',
    isauth: true,
    is_mobile: 'true',
    iconsvg: faUmbrella,
    icon_type: "FontAwesomeIcon",
  },
  {
    id: 8,
    parentid: 6,
    text: 'Affected Files',
    icon: 'k-i-minus',
    iconsvg: AffectedFileIcon,
    route: '/searchaffectedfiles',
    element: <AffectedFiles />,
    layouts: 'CardLayout',
    is_drawer_item: 'true',
    page_title: 'Affected Files',
    isauth: true,
    is_mobile: 'true',
    icon_type: "SVG",
  },
  {
    id: 9,
    parentid: 6,
    text: 'Object Changelog',
    icon: 'k-i-minus',
    iconsvg: ObjectChangeLogIcon,
    route: '/affectedfiles',
    element: <AffectedFileDetail />,
    layouts: 'CardLayout',
    is_drawer_item: 'true',
    page_title: 'Object Change Logs',
    isauth: true,
    is_mobile: 'true',
    icon_type: "SVG",
  },
  {
    id: 10,
    parentid: 6,
    text: 'Webhook Logs',
    icon: 'k-i-minus',
    iconsvg: webhookLogsIcon ,
    route: 'webhooklogs',
    element: <WebHookLogs />,
    layouts: 'CardLayout',
    is_drawer_item: 'true',
    page_title: 'Webhook Logs',
    isauth: true,
    is_mobile: 'true',
    icon_type: "SVG",
  },
  {
    id: 18,
    parentid: 6,
    text: 'Generate Rollout',
    icon: 'k-i-minus',
    route: '/generate-rollout',
    element: <GenerateRollout />,
    layouts: 'CardLayout',
    is_drawer_item: 'true',
    page_title: 'Generate Rollout',
    isauth: true,
    is_mobile: 'true',
    iconsvg:generateRolloutIcon,
    icon_type: "SVG",
  },
  {
    id: 7,
    text: 'Settings',
    icon: '',
    route: '/settings',
    element: <Setting />,
    layouts: 'CardLayout',
    is_drawer_item: 'true',
    page_title: 'Settings',
    isauth: true,
    is_mobile: 'true',
    iconsvg: faGear,
    icon_type: "FontAwesomeIcon",
  },
  {
    id: 11,
    text: 'My Account',
    icon: '',
    route: '/account',
    element: <Account />,
    layouts: 'CardLayout',
    is_drawer_item: 'false',
    page_title: 'My Account',
    isauth: true,
    is_mobile: 'true',
  },
  {
    id: 12,
    text: 'Create Rollout',
    icon: '',
    route: '/createrollout/:projectId/:versionId/:action/:major?/:name?',
    element: <CreateRollout />,
    layouts: 'CardLayout',
    is_drawer_item: 'false',
    go_back: true,
    go_back_link: '/projects',
    page_title: 'Create Rollout',
    isauth: true,
    is_mobile: 'true',
  },
  {
    id: 13,
    text: 'Rollout',
    icon: '',
    route: '/rolloutList/:projectId/:versionId',
    element: <RolloutList />,
    layouts: 'CardLayout',
    is_drawer_item: 'false',
    page_title: 'Rollout List',
    isauth: true,
    is_mobile: 'true',
  },
  {
    id: 14,
    text: 'Social Login Redirect',
    icon: '',
    route: 'social/login/callback',
    element: <SocialLoginRedirect />,
    layouts: 'EmptyLayout',
    is_drawer_item: 'false',
    page_title: 'Social Login Redirect',
    isauth: false,
    is_mobile: 'true',
  },
  {
    // OpenID and other providers can redirect here
    id: 19,
    text: 'Login Callback',
    icon: '',
    route: '/login/callback',
    element: <SocialLoginRedirect />,
    layouts: 'EmptyLayout',
    is_drawer_item: 'false',
    page_title: 'Login Callback',
    isauth: false,
    is_mobile: 'true',
  },
  {
    text: 'No Permission',
    route: '/no-permission',
    element: <NoPermission />,
    layouts: 'TileLayout',
    is_drawer_item: 'false',
    is_mobile: 'false',
  },
  {
    separator: true,
    is_drawer_item: 'true',
  },
];

const RoutesItems = RoutesItemsList;

export default RoutesItems;
